import { Grid2, SwipeableDrawer } from "@mui/material";
import { Outlet, useNavigate, useOutlet } from "react-router";
import "styles/index.scss";

import { useAppLayoutContext } from "components/contexts";
import { BOTTOM_NAV_HEIGHT, DEFAULT } from "routes/consts";

import { BottomNav, MainContent, Sidebar } from "./components";
import { PWAInstallDialog } from "./components/PWAInstallDialog";

export const AppLayout = () => {
  const outlet = useOutlet();
  const navigate = useNavigate();

  const { drawerStyles, setDrawerStyles } = useAppLayoutContext();

  return (
    <Grid2
      container
      direction={"column"}
      bgcolor={"background.default"}
      className="w-screen min-h-dvh h-full"
      sx={{
        scrollbarGutter: "stable",
        paddingTop: "65px",
        paddingBottom: `${BOTTOM_NAV_HEIGHT}px`,
        overflowX: "hidden",
      }}
    >
      <MainContent />
      <Sidebar />
      <SwipeableDrawer
        anchor="bottom"
        open={!!outlet}
        onOpen={() => {}}
        onClose={() => {
          navigate(DEFAULT);
        }}
        onTransitionEnd={() => {
          if (!outlet) setDrawerStyles({});
        }}
        disableDiscovery
        sx={{
          "& .MuiDrawer-paper": {
            height: "calc(100dvh - 64px)",
            maxHeight: "calc(100dvh - 64px)",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            bgcolor: "background.paper",
            backgroundImage: "none",
            paddingBottom: `${BOTTOM_NAV_HEIGHT}px`,
            ...drawerStyles,
          },
        }}
      >
        <Outlet />
      </SwipeableDrawer>
      <BottomNav />
      <PWAInstallDialog />
    </Grid2>
  );
};
